import React from "react";

export default function Telegram() {
  return (
    <div>
      <div className="container-fluid telegramcomp text-center">
        <h2>
          Do you want to get the <span>Daily Reminders</span> for Exercise ?
        </h2>

        <h4>Join our Reminder Bot on Telegram !</h4>

        <a
          href="https://t.me/fitnessjunction_bot"
          target="_blank"
          className=""
          role="button"
          aria-pressed="true"
        >
          {/* <i class="fa-brands fa-3x fa-telegram fa-icon"></i> */}
          <button type="button" class="btn bot-btn">
            Join Now
          </button>
        </a>
      </div>
    </div>
  );
}
